import axios from "axios";

export class InvestorWithdrawals {
    get(filters) {
        return axios.post(`/api/financials/withdrawals/investor`, { filters: filters })
    }
}